// // import makeAnimated from 'react-select/animated'
// import Select from 'react-select'
// import React, { useRef, useState, useEffect } from 'react'
// import PropTypes from 'prop-types'

// // const animatedComponents = makeAnimated()

// function Multiselect({ edit_data, data, name, isMulti, onChange, placeholder, style  }) {
//   const [values, setvalues] = useState(JSON.stringify(edit_data))

//   const handlechange = (e) => {
//     // console.log(JSON.stringify(e))
//     setvalues(JSON.stringify(e))
//      if (onChange) {
//       onChange(e)
//     }
//   }
//   return (
//     <>
//       {isMulti ? (
//         <Select
//           isMulti
//           closeMenuOnSelect={false}
//           defaultValue={edit_data}
//           onChange={handlechange}
//           placeholder={placeholder}
//           options={data}
//           styles={{
//             container: (provided) => ({
//               ...provided,
//               ...style  // Apply the style prop here
//             })
//           }}
//         />
//       ) : (
//         <Select
//           closeMenuOnSelect={true}
//           defaultValue={edit_data}
//           onChange={handlechange}
//           placeholder={placeholder}
//           options={data}
//           styles={{
//             container: (provided) => ({
//               ...provided,
//               ...style  // Apply the style prop here
//             })
//           }}
//         />
//       )}

//       <input type="hidden" value={values} name={name} />
//     </>
//   )
// }
// export default Multiselect

// Multiselect.propTypes = {
//   name: PropTypes.string.isRequired,
//   data: PropTypes.array,
//   edit_data: PropTypes.array,
//   isMulti: PropTypes.bool,
  
// }



import Select from 'react-select'
import React, { useState } from 'react'
import PropTypes from 'prop-types'

function Multiselect({ edit_data, data, name, isMulti, onChange, placeholder }) {
  const [values, setvalues] = useState(JSON.stringify(edit_data))

  const handlechange = (e) => {
    setvalues(JSON.stringify(e))
    if (onChange) {
      onChange(e)
    }
  }

 const customStyles = {
  container: (provided) => ({
    ...provided,
  }),
  control: (provided, state) => ({
    ...provided,
    minWidth: '150px',
    padding: '0 4px',
    fontSize: '14px',
    fontWeight: '300',
    boxShadow: state.isFocused ? '0 0 0 1px #2684FF' : 'none',
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '0 4px',
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: '14px',
    fontWeight: '300',
    color: '#999',
    margin: 0,
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: '14px',
    fontWeight: '400',
    padding: '6px 10px',
    backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
    color: '#777',
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: '14px',
    fontWeight: '300',
    color: '#777',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    fontSize: '14px',
    fontWeight: '300',
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
  }),
  clearIndicator: (provided) => ({
    ...provided,
    padding: '2px',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: '2px',
  }),
}


  return (
    <>
      <Select
        isMulti={isMulti}
        closeMenuOnSelect={!isMulti}
        defaultValue={edit_data}
        onChange={handlechange}
        placeholder={placeholder}
        options={data}
        styles={customStyles}
      />
      <input type="hidden" value={values} name={name} />
    </>
  )
}

export default Multiselect

Multiselect.propTypes = {
  name: PropTypes.string.isRequired,
  data: PropTypes.array,
  edit_data: PropTypes.array,
  isMulti: PropTypes.bool,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  style: PropTypes.object,
}
